<script setup>
import { ref, reactive, watch, onMounted } from 'vue'
import { useApi } from '@/composables/useApi'

const props = defineProps({
  isOpen: Boolean,
  itemData: { type: Object, default: null }
})

const emit = defineEmits(['close', 'save'])

const { fetchData: apiFetch } = useApi()

// Danh sách roles từ API
const roles = ref([])
const loadingRoles = ref(false)
const selectedRoleId = ref('')

const fetchRoles = async () => {
  if (roles.value.length > 0) return
  try {
    loadingRoles.value = true
    const res = await apiFetch('/api/roles/')
    roles.value = res?.data || []
  } catch (e) {
    roles.value = []
  } finally {
    loadingRoles.value = false
  }
}

watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    fetchRoles()
    if (props.itemData && props.itemData.roles && props.itemData.roles.length > 0) {
      selectedRoleId.value = props.itemData.roles[0].id
    } else {
      selectedRoleId.value = ''
    }
  }
})

const closeForm = () => {
  emit('close')
}

const handleSubmit = () => {
  if (!selectedRoleId.value) return
  emit('save', {
    id: props.itemData.id,
    role_id: selectedRoleId.value
  })
}
</script>

<template>
  <div v-if="isOpen" class="form-sidebar-overlay" @click.self="closeForm">
    <div class="form-sidebar">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="fw-bold m-0">Update User Role</h4>
        <button class="btn-close" @click="closeForm"></button>
      </div>

      <div class="user-info mb-4 p-3 rounded shadow-sm border-start border-4 border-primary" style="background-color: #f0f7ff;">
        <p class="mb-1 text-dark"><i class="fa fa-user me-2 text-primary"></i><strong>User:</strong> {{ itemData?.name }}</p>
        <p class="mb-0 text-dark"><i class="fa fa-envelope me-2 text-primary"></i><strong>Email:</strong> {{ itemData?.email }}</p>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label class="form-label fw-semibold">Select Role <span class="text-danger">*</span></label>
          <select class="form-select" v-model="selectedRoleId" :disabled="loadingRoles" required>
            <option value="">{{ loadingRoles ? 'Loading...' : 'Select role' }}</option>
            <option 
              v-for="role in roles" 
              :key="role.id" 
              :value="role.id"
            >
              {{ role.display_name || role.name }}
            </option>
          </select>
        </div>

        <div class="d-flex gap-2 mt-4">
          <button type="button" class="btn btn-secondary w-100" @click="closeForm">Cancel</button>
          <button type="submit" class="btn btn-primary w-100">
            Update Role
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.form-sidebar-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 9999 !important;
}
.form-sidebar {
  position: fixed;
  top: 0; right: 0;
  width: 420px; height: 100%;
  background: white;
  padding: 30px;
  box-shadow: -5px 0 15px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  overflow-y: auto;
}
@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
</style>
